<!-- 表3填写 -->

<template>
  <div class="tabCage table9E">
    <div class="tabTtl">
      <span v-if="pressType == 1">表 2-1：音像制品出版情况登记表</span>
      <span v-else>表 2-1：电子出版物出版情况登记表</span>
    </div>
    <div class="editArea">
      <el-form ref="paramCk" :model="params" :rules="rules">
        <table>
          <tr>
            <td class="edName">年份：</td>
            <td class="edInp">
              <el-select v-model="params.year" disabled size="small" placeholder="请选择">
                <el-option v-for="item in yearOpts" :key="item.code" :label="item.name" :value="item.code"> </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="edName">出版物名称：</td>
            <td class="edInpBig">
              <el-input v-model="params.publicationName" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">专用书号（ISBN 978-7-）：</td>
            <td class="edInp">
              <el-input v-model="params.isbn" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">载体形式：</td>
            <td class="edInp">
              <div class="areaTime" v-if="pressType == 1">
                <el-form-item prop="carrierForm" :inline-message="true">
                  <el-select v-model="params.carrierForm" size="small" disabled placeholder="请选择载体形式">
                    <el-option v-for="item in dicDats['C010']" :key="item.code" :label="item.name" :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="carrierFormQT"
                  :inline-message="true"
                  v-if="mediaTyp1[params.carrierForm] == '其他'">
                  <el-input size="small" v-model="params.carrierFormQT" disabled></el-input>
                </el-form-item>
              </div>
              <div class="areaTime" v-else-if="pressType == 2">
                <el-form-item prop="carrierForm" :inline-message="true">
                  <el-select v-model="params.carrierForm" size="small" disabled placeholder="请选择载体形式">
                    <el-option v-for="item in dicDats['C025']" :key="item.code" :label="item.name" :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  prop="carrierFormQT"
                  :inline-message="true"
                  v-if="mediaTyp2[params.carrierForm] == '其他'">
                  <el-input v-model="params.carrierFormQT" size="small" disabled></el-input>
                </el-form-item>
              </div>
            </td>
          </tr>
          <tr>
            <td class="edName">出版形式：</td>
            <td class="edInp">
              <el-select v-model="params.publicationForm" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C011']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="edName">节目来源/制作单位：</td>
            <td class="edInpBig">
              <el-input v-model="params.productionUnit" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">节目时长或容量(分钟/兆)：</td>
            <td class="edInp">
              <el-input-number
                v-model="params.programCapacity"
                disabled
                controls-position="right"
                :min="0"
                :controls="false"
                size="small"></el-input-number>
            </td>
          </tr>
          <tr v-if="numShow">
            <td class="edName">出版数量(张/盒)：</td>
            <td class="edInp">
              <el-input-number
                v-model="params.publicationQuantity"
                disabled
                :controls="false"
                controls-position="right"
                :min="0"
                size="small"></el-input-number>
            </td>
          </tr>
          <!-- <tr v-if="numShow">
            <td class="edName">发行数量(张/盒)：</td>
            <td class="edInp">
              <el-input-number
                v-model="params.issueQuantity"
                disabled
                :controls="false"
                controls-position="right"
                :min="0"
                size="small"></el-input-number>
            </td>
          </tr> -->
          <!-- <tr v-if="numShow">
            <td class="edName">发行单价(元)：</td>
            <td class="edInp">
              <el-input-number
                v-model="params.unitPrice"
                disabled
                :controls="false"
                controls-position="right"
                :min="0"
                size="small"></el-input-number>
            </td>
          </tr> -->
          <tr>
            <td class="edName">出版时间：</td>
            <td class="edInp">
              <el-date-picker
                disabled
                v-model="params.publishingTime"
                align="right"
                type="date"
                size="small"
                value-formate="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </td>
          </tr>
          <!-- <tr>
            <td class="edName">是否缴送样本：</td>
            <td class="edInp">
              <el-select v-model="params.sampleDelivery" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C018']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr> -->
          <tr>
            <td class="edName">是否书配盘标记：</td>
            <td class="edInp">
              <el-select v-model="params.sign" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C018']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </td>
          </tr>
        </table>
      </el-form>
    </div>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt9";
import { tabUpdate9, tabRead9 } from "@/api/pressRole/pressRole";
export default {
  data() {
    return {
      pressType: this.$route.query.pressType,
      params: bsParams,
      numShow: true,
      rules: paramsRule,
      mediaTyp1: {},
      mediaTyp2: {},
      submiting: false,
      dicDats: {},
      yearOpts: [
        { code: 2021, name: "2021年" },
        { code: 2022, name: "2022年" },
      ],
    };
  },
  methods: {
    dictInit: function () {
      let nameArr = ["C010", "C011", "C018", "C025", "C012"];
      let newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      let vm = this;
      newPromise.then((result) => {
        this.dicDats = result;
        vm.mediaTyp1 = vm.$store.getters.dictionary["C010"];
        vm.mediaTyp2 = vm.$store.getters.dictionary["C025"];
        this.mtReEdit();
      });
    },

    editSave: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.params.publishId = this.$route.query.pressId;
          this.params.publishMaterialId = this.$route.query.mtId;
          this.params.type = this.$route.query.pressType;

          tabUpdate9({ ppublication: this.params })
            .then((response) => {
              this.submiting = false;
              this.$message({
                message: "保存成功！",
                type: "success",
              });

              for (let key in this.params) {
                this.params[key] = "";
              }

              this.$router.replace({
                path: "view_tab9",
                query: {
                  pressId: this.$route.query.pressId,
                  mtId: this.$route.query.mtId,
                  pressType: this.$route.query.pressType,
                },
              });
            })
            .catch((error) => {
              this.submiting = false;
            });
        } else {
          return false;
        }
      });
    },

    btnCtrls: function (type, dats) {
      if (type == 1) {
        this.btnCtrls1 = false;
      } else if (type == 2) {
        this.btnCtrls2 = false;
      }
    },

    mtReEdit: function () {
      tabRead9({ id: this.$route.query.id }).then((response) => {
        this.params = response.ppublication;
        if (this.pressType == 1) {
          if (this.mediaTyp1[this.params.carrierForm] == "电子-信息网络出版") {
            this.numShow = false;
          } else {
            this.numShow = true;
          }
        } else if (this.pressType == 2) {
          if (this.mediaTyp2[this.params.carrierForm] == "电子-信息网络出版") {
            this.numShow = false;
          } else {
            this.numShow = true;
          }
        }
      });
    },

    goBack: function () {
      this.$router.go(-1);
    },
  },
  created: function () {
    this.dictInit();
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.table9E .edInp .el-input-number {
  width: 300px;
}

.table9E .edName {
  width: 240px !important;
}
</style>



// WEBPACK FOOTER //
// table9.vue?b0f12cec